import React, { lazy, Fragment, Suspense } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';
import { GetOrder } from '../../redux/checkout/orderConfirmation/orderconfirmAction';
import { Component } from 'react';
import CheckoutHeaderSkeleton from '../../skeleton/checkout/CheckoutHeaderSkeleton';
import ProductSideBarSkeleton from '../../skeleton/checkout/ProductSideBarSkeleton';
import OrderConfirmSkeleton from '../../skeleton/OrderConfirmSkeleton';
import { utils } from '../../utils/utils';
import ReactGA from 'react-ga';


ReactGA.set({ page: window.location.pathname }); // Update the user's current page
ReactGA.pageview(window.location.pathname + window.location.search); // Record a pageview for the given page
class OrderConfirmationPage extends Component {
    componentDidMount() {
        utils.removeNavFromCheckoutPages();
        const props = this.props;
        const { match, history, homePageUrl } = props;
        const orderId = match.params.orderid ? match.params.orderid.match(/[0-9]+/g) : 0;

        if (orderId > 0)
            this.props.getOrderInfobyId(orderId)
        else
            history.push({
                pathname: homePageUrl
            })

       
        
        if (document.getElementsByClassName("loader-wrapper")[0])
            document.getElementsByClassName("loader-wrapper")[0].style.display = "none";
    }

  
    render() {

        if (this.props.orderData && this.props.orderData.hasOwnProperty('travelDocument')) {
            const MainHeaderComponent = lazy(() => import('./MainHeader'));
            const ProductInfoWrapperComponent = lazy(() => import('./productSideBar/ProductInfoWrapper'));
            const HeaderComponent = lazy(() => import('./Header'));
            const GoToTravelDocSectionComponent = lazy(() => import('./GoToTravelDocSection'));
            const FooterComponent = lazy(() => import('./Footer'));

            const { pageData = {}, travelDocument = {}, rightFooter = {}, leftFooter = {} } = this.props.orderData
            return (
                <section className="check-out">

                    <div className="check-out-width">
                    <Suspense fallback={<CheckoutHeaderSkeleton></CheckoutHeaderSkeleton>}>
                            <MainHeaderComponent homePageUrl={this.props.homePageUrl}/>
                        </Suspense>
                        <Suspense fallback={<ProductSideBarSkeleton></ProductSideBarSkeleton>}>
                            <ProductInfoWrapperComponent orderData={this.props.orderData} />
                        </Suspense>
                        <Suspense fallback={<Fragment></Fragment>}>
                            <HeaderComponent pageData={pageData} />
                        </Suspense>
                        <Suspense fallback={<Fragment></Fragment>}>
                            <GoToTravelDocSectionComponent travelDocument={travelDocument} />
                        </Suspense>
                        <Suspense fallback={<Fragment></Fragment>}>
                            <FooterComponent rightFooter={rightFooter} leftFooter={leftFooter} />
                        </Suspense>

                    </div>
                </section>
            )
        }
        else {
            return (
                <OrderConfirmSkeleton></OrderConfirmSkeleton>
            )
        }
    }
}

const mapStateToProps = state => {

    return {
        orderData: state.orderConfirm || {}
    }
}
const mapDispatchToProps = dispatch => ({
    getOrderInfobyId: (orderId) => dispatch(GetOrder(orderId)),
})
const OrderConfirmationPageWithRouter = withRouter(OrderConfirmationPage);
export default connect(mapStateToProps, mapDispatchToProps)(OrderConfirmationPageWithRouter)
